
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.96 8.03l-2.22-2.22v7.69h-1.5V5.81L7 8.03 5.94 6.97 10 2.94l4 4.03-1.04 1.06zM18 16.875V11h-1.5v5.5h-13V11H2v5.875c0 .617.498 1.12 1.115 1.125h13.75A1.125 1.125 0 0 0 18 16.875z"}})])
          )
        }
      }
    